/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Capacitor } from "@capacitor/core";
import { useLocation } from "react-router-dom";

import logo from "../../../assets/images/FarmlandsProLogoWhite.svg";
import { TestIds } from "../../../testIds";
import onClickDeveloper from "../../../util/exportAuth";
import { useNavigateToItem } from "../hooks/useNavigateToItem";
import { NavItemModel } from "../NavItem";
import { isRouteActive } from "../utils/is-route-active";

import { SidebarNav } from "./SidebarNav";
import { useSideNavItems } from "./useSideNavItems";

const DesktopSidebarNav = () => {
  const { pathname } = useLocation();
  const navigateTo = useNavigateToItem();
  const items = useSideNavItems();

  const sideItems: NavItemModel[] = items.map((item) => ({
    id: item.destinationId,
    label: item.label,
    icon: <item.icon aria-hidden className="size-8" strokeWidth={1} />,
    isActive: isRouteActive(pathname, item.to),
    testId: item.testId,
    onSelect: () => navigateTo(item),
  }));

  return (
    <SidebarNav
      testId={TestIds.components.layout.nav.desktopDrawer}
      logo={<img src={logo} alt="Farmlands logo" className="w-full" />}
      onLogoClick={Capacitor.DEBUG ? () => onClickDeveloper() : undefined}
      items={sideItems}
    />
  );
};

export default DesktopSidebarNav;
